export default __webpack_public_path__ + "static/media/HolidayTemplate.8a3747cc.xlsx";